import { render, staticRenderFns } from "./Offset.vue?vue&type=template&id=8dde6b14&scoped=true"
import script from "./Offset.vue?vue&type=script&lang=js"
export * from "./Offset.vue?vue&type=script&lang=js"
import style0 from "./Offset.vue?vue&type=style&index=0&id=8dde6b14&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dde6b14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8dde6b14')) {
      api.createRecord('8dde6b14', component.options)
    } else {
      api.reload('8dde6b14', component.options)
    }
    module.hot.accept("./Offset.vue?vue&type=template&id=8dde6b14&scoped=true", function () {
      api.rerender('8dde6b14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/applet/setting/skinSetting/components/Offset.vue"
export default component.exports